import { DEFAULT_LOCALE } from "./constants";
import { useI18nContext } from "./I18nProvider";
import type { SupportedLocale } from "./types";

export function useI18nDisplayLocale(): SupportedLocale {
  const { isEnabled, locale } = useI18nContext();

  if (!isEnabled) {
    return DEFAULT_LOCALE;
  }

  return locale;
}
